const worksite = {
  "page": {
    "loading": "ページを読み込み中...",
  },
  "panel": {
    "membersTitle": "接続中の作業者",
    "membersEmpty": "接続中の作業者はいません",
    "membersCount": "全{{count}}名",
    "refreshMembers": "作業者の位置を更新",
    "unknownPosition": "位置不明",
    "pollingDegraded": "接続が遅延しています — 最後のスナップショットを表示中",
  },
  "role": {
    "owner": "所有者",
    "inspector": "点検者",
    "viewer": "ビューア",
  },
  "relative": {
    "justNow": "たった今",
    "minutesAgo": "{{value}}分前",
    "hoursAgo": "{{value}}時間前",
    "daysAgo": "{{value}}日前",
    "unknown": "-",
  },
  "member": {
    "role": "役割",
    "lastReported": "最終位置報告",
    "accuracy": "GPS精度",
    "violationState": "違反状態",
    "violationNone": "正常",
    "closeCard": "詳細カードを閉じる",
  },
  "violation": {
    "badge": "違反",
    "toast": "{{name}} — {{zone}} 立入禁止区域違反",
    "unknownZone": "立入禁止区域",
  },
  "marker": {
    "ariaLabel": "作業者 {{label}} マーカー",
    "violationSpoken": "立入禁止区域に違反中",
  },
  "layers3d": {
    "title": "レイヤー",
    "mesh": "現況メッシュ",
    "loading": "3Dレイヤーを読み込み中...",
    "empty": "表示する3Dレイヤー（メッシュ・BIM・GIS）がありません",
    "emptyModels": "表示する3Dレイヤー（メッシュ・BIM）がありません",
    "loadFailed": "読み込めませんでした",
    "count": "全{{count}}件",
  },
  "zones": {
    "manage": "立入禁止区域の管理",
    "count": "全{{count}}件",
    "empty": "登録された立入禁止区域はありません",
    "draw": "新しい立入禁止区域を描く",
    "drawingHint":
      "地図をクリックして頂点を配置し、ダブルクリックで完了します。ESC または右クリックでキャンセルできます。",
    "drawCancel": "描画をキャンセル",
    "rename": "名前を変更",
    "renameInput": "{{name}}の名前",
    "renameConfirm": "{{name}}の名前を保存",
    "renameCancel": "{{name}}の名前変更をキャンセル",
    "delete": "削除",
    "rowMenu": "{{name}} のメニュー",
    "active": "有効",
    "deleteConfirmTitle": "立入禁止区域の削除",
    "deleteConfirmMessage": "「{{name}}」区域を削除しますか？",
    "deleteConfirmSub": "元に戻せません。",
    "cancel": "キャンセル",
  },
  "zoneDialog": {
    "createTitle": "新しい立入禁止区域の名前",
    "renameTitle": "立入禁止区域の名前変更",
    "nameLabel": "区域名",
    "confirm": "確認",
    "cancel": "キャンセル",
    "tooFewPoints": "頂点を3つ以上配置してください",
  },
  "error": {
    "presencePoll": "接続中の作業者を読み込めませんでした — 自動的に再試行します",
    "presenceLoad": "接続中の作業者を読み込めませんでした",
    "projectNoLocation": "この現場には地図に表示する位置情報がありません",
    "projectLoad": "現場情報を読み込めませんでした",
    "zonesLoad": "立入禁止区域の一覧を読み込めませんでした",
    "zoneCreate": "立入禁止区域の作成に失敗しました",
    "zoneUpdate": "立入禁止区域の更新に失敗しました",
    "zoneDelete": "立入禁止区域の削除に失敗しました",
    "noPermission": "権限がありません",
  },
} as const;

export default worksite;
